module.exports = __webpack_public_path__ + "img/menkyo_gold.7419ee25.png";